<template>
    <GuideModal>
        <div class="forbidden-container">
            <img v-if="isNN" src="../images/forbidden-nn.png" width="" alt="" />
            <img v-else src="../images/forbidden-moomoo.png" alt="" />
            <div>{{ desc }}</div>
            <a v-if="forbiddenType === FORBIDDEN_TYPE.LOW_VERSION" @click="handleClick">{{ btnText }}</a>
        </div>
    </GuideModal>
</template>

<script >
// 屏蔽弹窗
import GuideModal from './guide-modal.vue';
import { ShareEventMarket, FORBIDDEN_TYPE, UPGRADE_LINK } from '../common/constants';
import { computed } from 'vue-demi';
import { _lang } from '../common/lang';
const __sfc_main = {};
__sfc_main.props = {
  market: {
    type: String,
    default: ''
  },
  forbiddenType: {
    type: String,
    default: 'notApp'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const isNN = computed(() => props.market === ShareEventMarket.HK);
  const desc = computed(() => {
    return _lang(`forbidden.desc.${props.forbiddenType}`);
  });
  const btnText = computed(() => {
    return _lang(`forbidden.btn.${props.forbiddenType}`);
  });

  // 屏蔽弹窗点击事件
  function handleClick() {
    if (props.forbiddenType === FORBIDDEN_TYPE.LOW_VERSION) {
      location.href = isNN.value ? UPGRADE_LINK.NN : UPGRADE_LINK.MOOMOO;
    }
  }
  return {
    FORBIDDEN_TYPE,
    isNN,
    desc,
    btnText,
    handleClick
  };
};
__sfc_main.components = Object.assign({
  GuideModal
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.forbidden-container {
    width: 5.8rem;
    padding: 0.57rem 0 0.4rem 0;
    flex-shrink: 0;
    border-radius: 0.4rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.28rem;
    color: #000;
    img {
        width: 4.8rem;
        height: 3.08rem;
        flex-shrink: 0;
    }
    div {
        margin: 0.64rem 0.58rem 0.4rem;
        color: #000;
        text-align: center;
        font-size: 0.36rem;
        font-style: normal;
        font-weight: 400;
    }
    a {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1.18rem;
        background: #ff6900;
        padding: 0.22rem 0.62rem 0.22rem 0.64rem;
        color: #fff;
        font-size: 0.38rem;
        font-style: normal;
        font-weight: 400;
        line-height: 146.4%;
        min-width: 4.18rem;
    }
}
</style>
